import {FC} from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  ArcElement,
  Tooltip,
  Legend,
  RadialLinearScale,
} from 'chart.js'
import {Bar, PolarArea} from 'react-chartjs-2'
import {DataCSRItem} from '../core/_models'
import {usersAPI} from '../../../services/UsersService'
import {useAppSelector} from '../../../hooks/redux'
import {formatPeriod} from '../helpers/period'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement, RadialLinearScale)

type Props = {
  items: DataCSRItem[]
}

const CSRChart: FC<Props> = ({items}) => {
  const {data: currentUser} = usersAPI.useFetchGetMeQuery()
  const query = useAppSelector((state) => state.csrFilter)
  const labels = items.map((i) => formatPeriod(i.date, query.group_by, currentUser?.language, currentUser?.time_zone))

  const dataBar = {
    labels,
    datasets: [
      {
        label: 'Вх.',
        data: items.map((i) => i.inbound),
        backgroundColor: 'rgba(54, 162, 235, 0.7)',
        borderWidth: 1,
        borderRadius: 5,
      },
      {
        label: 'Исх.',
        data: items.map((i) => i.outbound),
        backgroundColor: 'rgba(75, 192, 192, 0.7)',
        borderWidth: 1,
        borderRadius: 5,
      },
      {
        label: 'Проп.',
        data: items.map((i) => i.missed),
        backgroundColor: 'rgba(255, 99, 132, 0.7)',
        borderWidth: 1,
        borderRadius: 5,
      },
    ],
  }

  const totalinbound = items.reduce((sum, i) => sum + i.inbound, 0)
  const totaloutbound = items.reduce((sum, i) => sum + i.outbound, 0)
  const totalMissed = items.reduce((sum, i) => sum + i.missed, 0)

  const dataPolarArea = {
    labels: ['Вх.', 'Исх.', 'Проп.'],
    datasets: [
      {
        label: 'Звонки',
        data: [totalinbound, totaloutbound, totalMissed],
        backgroundColor: ['rgba(54, 162, 235, 0.7)', 'rgba(75, 192, 192, 0.7)', 'rgba(255, 99, 132, 0.7)'],
        borderWidth: 1,
        borderRadius: 5,
      },
    ],
  }

  return (
    <div className='row'>
      <div className='col-8'>
        <Bar
          data={dataBar}
          options={{
            responsive: true,
            plugins: {
              legend: {position: 'top'},
            },
          }}
        />
      </div>
      <div className='col-4'>
        <PolarArea
          data={dataPolarArea}
          options={{
            responsive: true,
            plugins: {
              legend: {position: 'top'},
            },
          }}
        />
      </div>
    </div>
  )
}

export {CSRChart}
